'use client';

export { default } from './ButtonBase';
export { default as buttonBaseClasses } from './buttonBaseClasses';
export * from './buttonBaseClasses';
export { default as touchRippleClasses } from './touchRippleClasses';
export * from './touchRippleClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ButtonBase/index.js
// module id = 48
// module chunks = 25